(function($){
    window.Application = {
        ready: function () {
            this.Tabs.init();
            this.Dropzone.init();
            this.CurrencyField.init();
            this.Donate.ready();
        },
        Tabs: {
            init: function(){
                $('.js-tabs a').on('click',function(e){
                    e.preventDefault();
                    var $el = $(this),
                        $tab = $el.parent(),
                        $panelId = $tab.data('tab'),
                        $panel = $('#'+$panelId),
                        $clActive = 'active';
                    if(!$tab.hasClass($clActive)){
                        $tab.siblings('.'+$clActive).removeClass($clActive);
                        $tab.addClass($clActive);
                        $panel.siblings('.'+$clActive).removeClass($clActive);
                        $panel.addClass($clActive);
                    }
                });
            }
        },
        Dropzone: {
            ui: {
                container: '.js-dropzone',
                upload: '.js-dropzone__upload',
                input: '.js-dropzone__input',
            },
            init: function(){

                var self = this;

                Dropzone.autoDiscover = false;

                $(this.ui.upload).each(function(){

                    var $container = $(this).closest(self.ui.container);

                    var dropzone = new Dropzone(this, {
                        url: $container.data('url'),
                        acceptedFiles: 'image/jpeg,image/png',
                        maxFiles: 1,
                        maxFilesize: 1024 * 1024 * 10, // 10 MB
                        paramName: "file", // name in $_FILES
                        init: function() {
                            // limit to 1 file, always overwrite the previous one
                            this.on("maxfilesexceeded", function(file) {
                                this.removeAllFiles();
                                this.addFile(file);
                            });
                            // disabled submit while uploading
                            this.on("addedfile", function() {
                                $container.addClass('uploading');
                            });
                            this.on("complete", function() {
                                $container.removeClass('uploading');
                            });
                            // on succesful upload
                            this.on("success", function(file, response) {
                                if (response.success) {
                                    $container.find(self.ui.input).val(response.data.filename).trigger('change');
                                } else {
                                    console.error("Upload failed", response);
                                }
                            });
                            // on remove file
                            this.on("removedfile", function(file) {
                                $container.find(self.ui.input).val('').trigger('change');
                            });
                        }
                    });
window.dropzone1 = dropzone;

                });

            }
        },
        CurrencyField: {
            init: function(){
                $('.js-currency').each(function(){
                    var $input = $(this);
                    $input.inputmask({
                        min: $(this).attr('data-min'),
                        suffix: ' ' + $(this).attr('data-currency'),
                        groupSeparator: " ",
                        alias: "numeric",
                        digits: 0,
                        digitsOptional: !1,
                        showMaskOnFocus: false,
                        showMaskOnHover: false,
                        rightAlign: false,
                        oncleared: function(){ $input.trigger('inputmask-cleared'); },
                        onincomplete: function(){ $input.trigger('inputmask-incomplete'); },
                        oncomplete: function(){ $input.trigger('inputmask-complete'); }
                    });
                });
            }
        }
    };
})(jQuery);

// Initiate the application
jQuery(function () {
    Application.ready();
});